<template>
    <div>
        <div class="contianer">
            <!-- 顶部标题 -->
            <div class="shoppingCat_title">
                <span class="shoppingCat_back" @click="goLink()"></span>
                <span class="shoppingCat_text ">收获地址</span>
            </div>

            <!-- 没有收获地址 -->
            <div class="noAddressBox">
                <div class="noAddress">
                    <div class="noAddress_top">
                        <div class="noAddress_top_img">
                            <img src="/static/images/order/addressOrder.png" alt="地址">
                        </div>
                        <div class="noAddress_top_text">
                            <span>您还没有收货地址</span>
                        </div>
                    </div>
                    <!-- 添加收货地址 -->
                    <div class="noAddress_bottomBox">
                        <div class="noAddress_bottom">
                            <div class="noAddress_bottom_add">
                                <img src="/static/images/order/plus.png" alt="add">
                                <span>添加收货地址</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
               
            }
        },

        methods:{
        }
    }
</script>


<style scoped lang="scss">
/*  引入外部scss文件 */
@import "../../../static/css/address.scss";
</style>


// WEBPACK FOOTER //
// src/pages/Address/Address.vue